import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/internal/Observable'
import { catchError, retry } from 'rxjs/operators'
import { environment } from '../../environments/environment'
@Injectable({
  providedIn: 'root',
})
export class LoginService {
  options: any
  encryptedData: any
  
  constructor(private http: HttpClient) {
    const headers: any = new HttpHeaders({
      'Content-Type': 'application/json',
    })
    this.options = { headers }
  }

  login(data: any): Observable<any> {
    const sendData: any = {
      email: data.email,
      password: data.password,
      user_type: data.userType,
    }
    if (data.userType === 'brand') {
      return this.http.post(
        environment.apiUrl + 'brandAdmin/login/',
        sendData,
        this.options
      )
    } else {
      return this.http.post(
        environment.apiUrl + 'superadmin/login/',
        sendData,
        this.options
      )
    }
  }

  getUserInfo(data: any): Observable<any> {
    const headers: any = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: data.tokenType + ' ' + data.accessToken,
    })
    this.options = { headers }

    if (data.userType === 'brand') {
      return this.http.get(
        environment.apiUrl + 'brandAdmin/profile/',
        this.options
      )
    } else {
      return this.http.get(environment.apiUrl + 'admin/profile/', this.options)
    }
  }

  forGotPassword(data: any): Observable<any> {
    const sendData: any = { email: data.email, user_type: data.userType }
    if (data.userType == 'brand') {
      return this.http.post(environment.apiUrl + 'password/forgot/', sendData)
    } else {
      return this.http.post(environment.apiUrl + 'password/forgot/', sendData)
    }
  }

  resetPassword(data: any): Observable<any> {
    const sendData: any = {
      new_password: data.password,
      forgot_password_public_id: data.forgotPasswordPublicId,
      otp: data.otp,
      email: data.email,
    }
    return this.http.post(environment.apiUrl + 'password/update/', sendData)
  }
}
